import { type FlowV2_TemplateString } from '~/graphql/types';

const isTemplateString = (subject: any): subject is FlowV2_TemplateString =>
  subject && subject.__typename === 'FlowV2_TemplateString';

export default isTemplateString;
